export default "__VITE_ASSET__0ab19fc4__"